
  export default {
    name: 'information-component',
    props:[
        'items'
    ]
  }
